import { render, staticRenderFns } from "./VueCharts.vue?vue&type=template&id=0a0d7b28&"
import script from "./VueCharts.vue?vue&type=script&lang=js&"
export * from "./VueCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports